module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.4-choose-component.934ddb59.png";